<section id="secao-servicos-e-cursos">
  <div class="container">
    <div class="servicos">
      <div class="title">
        <h1>Serviços oferecidos a graduadas</h1>
      </div>
      <div class="servicos-oferecidos">
        <ul>
          <li>impressão 3D</li>
          <li>Open inovation</li>
          <li>Projeto mecânico</li>
          <li>Locação de Laboratórios e Salas de treinamento</li>
          <li>Locação de estudio Audiovisual</li>
        </ul>
      </div>
    </div>
    <div class="cursos">
      <div class="title-2">
        <h1>Cursos, Oficinas, Workshops oferecidos aos incubados</h1>
      </div>
      <div class="cursos-oferecidos">
        <ul>
          <li>Formação do preço de Venda</li>
          <li>Planejamento Financeiro</li>
          <li>Viabilidade Econômica e Financeira</li>
          <li>Pesquisa de Mercado</li>
          <li>Ferramentas de Validação de Mercado</li>
          <li>Prospecção ativa de clientes</li>
          <li>Prototipação</li>
          <li>Validação de Produto e Processo</li>
          <li>Planejamento de Produção</li>
          <li>Gestão de Qualidade</li>
          <li>Certificação Inmetro</li>
          <li>Certificação Anvisa</li>
          <li>Gestão de Pessoas e Equipes</li>
          <li>Gestão de Processos internos</li>
          <li>Gestão de Negócio</li>
          <li>Ferramentas de modelagem de negócio</li>
          <li>Desenvolvimento Pessoal</li>
          <li>Planejamento financeiro pessoal</li>
          <li>Psicologia crítica</li>
          <li>Comportamento pessoal</li>
        </ul>
      </div>
    </div>
  </div>
</section>
